module.exports = __webpack_public_path__ + "static/media/bar.8657e8ed.jpg";